import type {
  FoodContainer,
  IsoDate,
  RotationAlertReceipt,
  RotationAlertThreshold,
} from './model';

const DAY_MS = 86_400_000;

const dayValue = (value: IsoDate): number => Date.parse(`${value}T12:00:00.000Z`);

const addDays = (value: IsoDate, days: number): IsoDate =>
  new Date(dayValue(value) + days * DAY_MS).toISOString().slice(0, 10);

export const ROTATION_ALERT_POLICY_VERSION = 'rotation-thresholds-v1';

export const rotationThresholdDates = (
  optimalUseOn: IsoDate,
): Record<RotationAlertThreshold, IsoDate> => ({
  'j-7': addDays(optimalUseOn, -7),
  'j-2': addDays(optimalUseOn, -2),
  j: optimalUseOn,
  overdue: addDays(optimalUseOn, 1),
});

export const dueRotationAlerts = (
  container: FoodContainer,
  today: IsoDate,
  createdAt: string,
): RotationAlertReceipt[] => {
  if (
    !['draft', 'present', 'partial'].includes(container.status) ||
    container.qualityHorizonOn == null ||
    container.incidentStatus === 'unresolved'
  ) {
    return [];
  }
  const existing = new Set(container.rotationAlerts.map((alert) => alert.threshold));
  const createdOn = container.createdAt.slice(0, 10);
  const due = (
    Object.entries(rotationThresholdDates(container.qualityHorizonOn)) as Array<
      [RotationAlertThreshold, IsoDate]
    >
  )
    .filter(
      ([threshold, triggeredOn]) =>
        !existing.has(threshold) &&
        triggeredOn >= createdOn &&
        triggeredOn <= today,
    )
    .map(([threshold, triggeredOn]) => ({
      threshold,
      triggeredOn,
      createdAt,
      state: 'unread' as const,
    }));
  return due.slice(-1);
};
